import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import auth from './auth';
import user from './user';
import services from './services';
import referent from './referent';
import facilita from './facilita';
import ImpressionReducer from './backoffice/impression';
import PartnersBackofficeReducer from './backoffice/partners';
import DossiersBackofficeReducer from './backoffice/dossiers';
import ClientsBackofficerReducer from './backoffice/clients';
import facilitaDeathDeclaration from './facilita/deathDeclaration';

import TeleconseillersReducer from './funecap/teleconseillers';
import DossierReducer from './funecap/dossiers';
import SelfcareReducer from "./funecap/selfcare";
import ActivityLogReducer from './funecap/activityLog';

import PartnerReducer from './partner';
import UserBackOfficeDetailReducer from './backoffice/user';
import PaymentReducer from './backoffice/payments';
import ConfigurationReducer from './backoffice/configuration';


const Reducer = (history) => {
  if (history.location.pathname.startsWith("/auth/referent")) {
    return combineReducers({
      router: connectRouter(history),
      referent
    });
  }

  if (history.location.pathname.startsWith("/backoffice")) {
    let reducers = {
			impressionReducer: ImpressionReducer,
			partnersReducer: PartnersBackofficeReducer,
			dossiersReducer: DossiersBackofficeReducer,
			selfcareReducer: SelfcareReducer,
			clientsReducer: ClientsBackofficerReducer,
			paymentReducer: PaymentReducer,
			userBackOfficeDetailReducer: UserBackOfficeDetailReducer,
			configurationReducer: ConfigurationReducer,
			user,
			auth,
		};

    reducers.router = connectRouter(history);
    return combineReducers(reducers);
  }

  if (history.location.pathname.startsWith("/partner")) {
    let reducers = {
      partnerReducer: PartnerReducer,
      user,
      auth
    };

    reducers.router = connectRouter(history);
    return combineReducers(reducers);
  }

  if (history.location.pathname.startsWith("/funecap")) {
    let reducers = {
			partnerReducer: PartnerReducer,
			user,
			auth,
			//clientsReducer: ClientsBackofficerReducer,
			teleconseillersReducer: TeleconseillersReducer,
			selfcareReducer: SelfcareReducer,
			dossiersReducer: DossierReducer,
			userBackOfficeDetailReducer: UserBackOfficeDetailReducer,
			activityLogReducer: ActivityLogReducer,
		};

    reducers.router = connectRouter(history);
    return combineReducers(reducers);
  }

  if (history.location.pathname.startsWith("/facilita")) {
    let reducers = {
      facilita,
      deathDeclaration: facilitaDeathDeclaration,
      user
    };

    // var pattern = /^\/facilita\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/declarer\/\w*/i;
    // if(pattern.test(history.location.pathname) === true){
    //   reducers = {...reducers, deathDeclaration: facilitaDeathDeclaration}; 
    // }

    reducers.router = connectRouter(history);
    return combineReducers(reducers);
  }

  return combineReducers({
    router: connectRouter(history),
    auth,
    user,
    services
  });

};
export default Reducer;